import { axiosClient } from './AxiosClient'

const newsType = {
    NORMAL: "NORMAL",
    VOTE: "VOTE",
    REGISTER: "REGISTER",
    INFORM: "INFORM",
    QUIZ: "QUIZ"
}

function listNews(page, size, isGlobal, companyId, callback, errorCallback){
    let url = "/news/admin/list"

    var bodyForm = new FormData()
    bodyForm.append("page", page)
    bodyForm.append("size", size)
    bodyForm.append("building_id", localStorage.getItem('building_id'))
    if(isGlobal){
        bodyForm.append("is_global", isGlobal)
    }else{
        if(companyId !== ""){
            bodyForm.append("company_id", companyId)
        }else{
            bodyForm.append("is_global", isGlobal)
        }
    }
    

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewNews(newsId, callback, errorCallback){
    let url = "/news/admin/view"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteNews(newsId, callback, errorCallback){
    let url = "/news/admin/delete"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createNews(
    title, 
    subTitle, 
    content, 
    publisher,
    type, 
    imageId, 
    isGlobal, 
    publishDate, 
    expireDate,
    maximumRegister,
    isShowVisitor,
    isShowInformationScreen,
    callback, 
    errorCallback
){

    let url = "/news/admin/create"

    var bodyForm = new FormData()
    bodyForm.append("title", title)
    bodyForm.append("sub_title", subTitle)
    bodyForm.append("content", content)
    bodyForm.append("publisher", publisher)
    bodyForm.append("type", type)
    bodyForm.append('building_id', localStorage.getItem('building_id'))
    if(imageId !== null){
        bodyForm.append("image_id", imageId)
    }
    if(type === newsType.REGISTER){
        bodyForm.append("maximum_register", maximumRegister)
    }
    bodyForm.append("is_global", isGlobal)
    bodyForm.append("publish_date", publishDate)
    bodyForm.append("news_expired_date", expireDate)
    bodyForm.append("point_expired_date", expireDate)
    bodyForm.append("is_show_visitor", isShowVisitor)
    bodyForm.append("is_show_information_screen", isShowInformationScreen)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        console.log(error.response)
        errorCallback(error)
    })
}

function addNewsImages(newsId, imageId, callback, errorCallback){
    let url = "/news/admin/add_image"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)
    bodyForm.append("image_id", imageId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeNewsImages(newsId, imageId, callback, errorCallback){
    let url = "/news/admin/remove_image"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)
    bodyForm.append("image_id", imageId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function addNewsDepartment(newsId, departmentId, callback, errorCallback){
    let url = "/news/admin/add_department"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeNewsDepartment(newsId, departmentId, callback, errorCallback){
    let url = "/news/admin/remove_department"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function addMultipleChoice(choices, newsId, callback, errorCallback){
    let url = "/news/admin/addChoice"
    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)
    choices.map((item)=>{
        bodyForm.append("choices[]", item)
    })

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeMultipleChoice(newsId, callback, errorCallback){
    let url = "/news/admin/removeChoice"
    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function markAnswerChoice(choiceId, callback, errorCallback){
    let url = "/news/admin/markAnswer"
    var bodyForm = new FormData()
    bodyForm.append("choice_id", choiceId)
    bodyForm.append("answer", true)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback()
    })
}

function updateNews(
    newsId,
    title, 
    subTitle, 
    publisher,
    content, 
    type, 
    imageId, 
    isGlobal, 
    publishDate, 
    expireDate,
    maximumRegister,
    isShowVisitor,
    isShowInformationScreen,
    callback, 
    errorCallback
){

    let url = "/news/admin/edit"

    var bodyForm = new FormData()
    bodyForm.append("news_id", newsId)
    bodyForm.append("title", title)
    bodyForm.append("sub_title", subTitle)
    bodyForm.append("content", content)
    bodyForm.append("publisher", publisher)
    bodyForm.append("type", type)
    if(imageId !== null){
        bodyForm.append("image_id", imageId)
    }
    if(type === newsType.REGISTER){
        bodyForm.append("maximum_register", maximumRegister)
    }
    bodyForm.append("is_global", isGlobal)
    bodyForm.append("publish_date", publishDate)
    bodyForm.append("news_expired_date", expireDate)
    bodyForm.append("point_expired_date", expireDate)
    bodyForm.append("is_show_visitor", isShowVisitor)
    bodyForm.append("is_show_information_screen", isShowInformationScreen)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        console.log(error.response)
        errorCallback(error)
    })
}

function listCommment(page, size, newsId, callback, errorCallback){
    let url = "/comment/admin/list"

    var bodyForm = new FormData()
    bodyForm.append("page", page)
    bodyForm.append("size", size)
    bodyForm.append("newsId", newsId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteComment(commentId, callback, errorCallback){
    let url = "/comment/admin/delete"

    var bodyForm = new FormData()
    bodyForm.append("comment_id", commentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { 
    listNews, 
    deleteNews,
    createNews, 
    addNewsImages, 
    removeNewsImages,
    addNewsDepartment,
    removeNewsDepartment,
    addMultipleChoice,
    removeMultipleChoice,
    markAnswerChoice,
    viewNews,
    updateNews,
    newsType,
    listCommment,
    deleteComment
}